// @flow
import React from 'react';
import qs from 'qs';
import CapacitorRipple from '../capacitor/Ripple';
import { Link, withRouter } from 'react-router';

declare var __CAPACITOR__: boolean;

type OwnProps = {
  pathname: string,
  query: Object,
  className?: string,
  title: React$Element<any> | string,
  onClickClear?: Function,
  router: Object,
};

function generateLinkTo(pathname, query) {
  const keysToKeep = ['sort', 'searchTerm'];
  const filteredQuery = {};
  for (const key in query) {
    if (keysToKeep.includes(key)) {
      filteredQuery[key] = query[key];
    }
  }

  return pathname + '?' + qs.stringify(filteredQuery);
}

const ClearAllActiveFacets = ({
  pathname,
  query,
  className,
  title,
  onClickClear,
  router,
}: OwnProps) => {
  const linkTo = generateLinkTo(pathname, query);

  const onClick = event => {
    if (__CAPACITOR__) {
      event.preventDefault();
      router.replace(linkTo);
    }
    if (onClickClear) {
      onClickClear(event);
    }
  };

  return (
    <Link
      to={linkTo}
      className={className}
      data-test="facet.groups.clear-all-active-facets"
      onClick={onClick}
    >
      <CapacitorRipple />
      {title}
    </Link>
  );
};

export default withRouter(ClearAllActiveFacets);
